import { Box, Typography } from '@mui/material';

interface JsonDiffProps {
  oldValues?: string;
  newValues?: string;
}

function tryPretty(json?: string) {
  if (!json) return null;
  try {
    return JSON.stringify(JSON.parse(json), null, 2);
  } catch {
    return json;
  }
}

export function JsonDiff({ oldValues, newValues }: JsonDiffProps) {
  const old = tryPretty(oldValues);
  const next = tryPretty(newValues);

  if (!old && !next) {
    return (
      <Typography variant="caption" sx={{ color: 'text.disabled' }}>
        No value changes recorded
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'flex', gap: 1.5, mt: 1, maxHeight: 280, overflow: 'hidden' }}>
      {old && (
        <Box sx={{ flex: 1, overflow: 'auto', maxHeight: 280 }}>
          <Typography
            variant="overline"
            sx={{ color: '#EF4444', mb: 0.5, display: 'block' }}
          >
            Before
          </Typography>
          <Box
            component="pre"
            sx={{
              m: 0,
              p: 1.5,
              backgroundColor: 'rgba(239,68,68,0.06)',
              borderRadius: '6px',
              border: '1px solid rgba(239,68,68,0.15)',
              fontSize: '0.7rem',
              fontFamily: '"Fira Code", "JetBrains Mono", monospace',
              color: '#FCA5A5',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-all',
              lineHeight: 1.6,
              '&::-webkit-scrollbar': { width: 3 },
              '&::-webkit-scrollbar-thumb': { background: '#334155', borderRadius: 2 },
            }}
          >
            {old}
          </Box>
        </Box>
      )}
      {next && (
        <Box sx={{ flex: 1, overflow: 'auto', maxHeight: 280 }}>
          <Typography
            variant="overline"
            sx={{ color: '#10B981', mb: 0.5, display: 'block' }}
          >
            After
          </Typography>
          <Box
            component="pre"
            sx={{
              m: 0,
              p: 1.5,
              backgroundColor: 'rgba(16,185,129,0.06)',
              borderRadius: '6px',
              border: '1px solid rgba(16,185,129,0.15)',
              fontSize: '0.7rem',
              fontFamily: '"Fira Code", "JetBrains Mono", monospace',
              color: '#6EE7B7',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-all',
              lineHeight: 1.6,
              '&::-webkit-scrollbar': { width: 3 },
              '&::-webkit-scrollbar-thumb': { background: '#334155', borderRadius: 2 },
            }}
          >
            {next}
          </Box>
        </Box>
      )}
    </Box>
  );
}
